/* eslint-disable no-loop-func */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import MainMenuItem from './MainMenuItem';
import ABCyaLib from '@abcya/abcya_lib';
import Games from '../Games';

export default class SubMenu extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene) {
    super(scene);

    this.myRect = { width: 200, height: 1600 };
    this.menuItems = [];
    this.menuTrash = [];

    this.graphics = this.scene.add.graphics();
    this.add(this.graphics);

    this.graphics.fillStyle(0xffff00, 1);
    this.graphics.fillRoundedRect(0, 0, this.myRect.width, this.myRect.height, { tl: 0, tr: 20, bl: 0, br: 20 });

    this.setSize(this.myRect.width, this.myRect.height);
  }

  changeMenu(parentIndex, c) {
    // Get rid of any current items
    let count = this.menuItems.length;
    for (let i = 0; i < count; i++) {
      const m = this.menuItems[i];
      this.menuTrash.push(m);
      m.goAway();
    }

    this.menuItems = [];

    let foundSprite = true;
    let item;
    let totalHeight = 0;
    let y = 10;
    let i = 0;

    const atlasToUse = this.scene.textures.get(gameData.game === Games.alphabet && !(parentIndex === 2 || parentIndex === 3) ? ABCyaPhaser.Images.LOCALIZATION_ATLAS : ABCyaPhaser.Images.DEFAULT_ATLAS);

    while (foundSprite) {
      const spritename = atlasToUse.has(`Submenu_${parentIndex + 1}_${i + 1}`);
      if (!spritename) {
        foundSprite = false;
        continue;
      }

      item = new MainMenuItem(this.scene, this, parentIndex, i, atlasToUse.key);
      item.x = this.myRect.width / 2 - item.getBounds().width / 2;
      item.y = y;
      y = item.y + item.getBounds().height;
      totalHeight += item.getBounds().height;
      this.menuItems.push(item);
      this.add(item);

      const data = { pNum: parentIndex, mNum: i };

      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {this.handleItemSelect(data);});
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.handleReleaseItem, this);
      i++;
    }

    // Changing it to spread items out of fixed height
    const customLayout = ABCyaLib.Environment.instance.gameConfig.layout;
    count = this.menuItems.length;
    let spaceToFill = this.myRect.height - totalHeight;
    spaceToFill = spaceToFill / count - 1; //
    let currentY = spaceToFill / 2;
    for (i = 0; i < count; i++) {
      item = this.menuItems[i];

      if (customLayout[parentIndex].length <= 0) { // Spread them out in one column
        item.y = currentY;
        currentY += item.getBounds().height + spaceToFill;
      }
      else { // Manually lay them out
        item.x = customLayout[parentIndex][i].x;
        item.y = customLayout[parentIndex][i].y;
      }
    }
    this.destHeight = totalHeight;
    this.color = c;

    this.setSize(this.myRect.width, this.myRect.height);

    this.graphics.clear();
    this.graphics.fillStyle(c, 1);
    this.graphics.fillRoundedRect(-50, 0, this.myRect.width + 50, this.myRect.height, { tl: 0, tr: 20, bl: 0, br: 20 });
  };

  handleItemSelect(item) {
    const d = { menuNum: 0, subMenuNum: 0 };
    d.menuNum = item.pNum;
    d.subMenuNum = item.mNum;

    this.emit('SELECTED_ITEM', d);
  };

  handleReleaseItem() {
    this.emit('RELEASE_ITEM');
  };

  destroyMenuItem(item) {
    const index = this.menuTrash.indexOf(item);
    this.menuTrash.splice(index,1);
    item.destroy();
  };
}